import * as React from 'react';

import styles from './case-report-info.scss';

interface CaseListingInfoProps {
  message: string;
}

export const CaseListingInfo = React.memo(({
  message
}: CaseListingInfoProps) => {
  return (
    <div className={styles.noResultsFound}>
      <div>{message}</div>
    </div>
  );
});

